import React from "react";
import { MdListAlt } from "react-icons/md";
import { colors, spacing } from "../library/theme";
import { css } from "glamor";

const container = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: spacing.m,
  textAlign: "center",
  width: "100%",
});
const icon = {
  color: colors.primaryDarker,
  marginBottom: spacing.s,
};
const titleStyle = {
  marginBottom: spacing.xxs,
};

export default function Empty({
  title = "Lista vazia",
  description = "Nada por aqui...",
}) {
  return (
    <div className={container}>
      <MdListAlt size={64} style={icon} />
      <h4 style={titleStyle}>{title}</h4>
      <span>{description}</span>
    </div>
  );
}
